<template>
  <div class="skill-dive-section">
    <div v-if="showHeader" class="skill-dive-section__title-container">
      <h1 class="skill-dive-section__title">Skill Dive</h1>
      <img
        :src="require(`@/assets/images/skill_dive_addon.png`)"
        alt="Skill Dive Popular Add-on"
        class="skill-dive-section__title-addon"
      />
    </div>

    <template v-if="!userHasSkillDive">
      <div v-if="showHeader" class="skill-dive-section__intro">
        An immersive lab experience featuring thousands of hands-on labs.
        <a target="_blank" href="https://ine.com/dive">Learn more</a> about Skill Dive.
      </div>
      <div class="skill-dive-section__plans--cyber-monday" v-if="isCyberMondayActive">
        <span>Cybermonday</span>
        <CyberMondayArrow class="skill-dive-section__plans--cyber-monday--arrow" />
        <span>2 DAYS ONLY</span>
        <CyberMondayArrow class="skill-dive-section__plans--cyber-monday--arrow" />
        <span class="skill-dive-section__plans--cyber-monday--text-mobile">50% OFF</span>
        <span class="skill-dive-section__plans--cyber-monday--text">50% OFF SKILL DIVE</span>
      </div>
      <div class="skill-dive-section__plans">
        <PlanSkillDiveItemCard />
      </div>
    </template>
    <template v-else>
      <div class="skill-dive-section__subscribed">
        <div class="skill-dive-section__subscribed-title">You have Skill Dive</div>
        <div class="skill-dive-section__subscribed-subtitle">
          {{ subtitle }}
        </div>
        <div class="skill-dive-section__subscribed-cta">
          <a
            :href="profileSubscriptionsUrl"
            class="btn btn--primary"
            :disabled="hasSkillDiveFullLearningAreas"
          >
            Manage Skill Dive
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PlanSkillDiveItemCard from '@/components/plan-item-card/PlanSkillDiveItemCard.vue'
import CyberMondayArrow from '@/assets/images/hero-section/cyber-monday/cm-arrows.svg'

export default {
  name: 'SkillDiveSection',
  components: {
    PlanSkillDiveItemCard,
    CyberMondayArrow,
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
    ...mapGetters({
      userHasSkillDive: 'subscriptions/userHasSkillDive',
      hasSkillDiveFullLearningAreas: 'subscriptions/hasSkillDiveFullLearningAreas',
      isCyberMondayActive: 'featureFlags/isCyberMondayActive',
    }),
    profileSubscriptionsUrl() {
      return `//${process.env.VUE_APP_STREAMING_URL}/dashboard/subscriptions`
    },
    subtitle() {
      if (this.hasSkillDiveFullLearningAreas)
        return 'You have access to all Skill Dive learning areas.'
      return 'Visit my.ine.com to add learning areas'
    },
  },
}
</script>

<style lang="scss" scoped>
.skill-dive-section {
  margin-bottom: 60px;
  &__title-container {
    display: flex;
    gap: 14px;
    align-items: center;
    margin-bottom: 10px;
  }
  &__title {
    font-size: rem(24px);
    line-height: rem(32px);
    font-style: normal;
    font-weight: 700;
    margin: 0;
  }
  &__title-addon {
    height: 26px;
  }
  &__intro {
    color: var(--light-blue-gray);
    font-size: rem(18px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(24px);
    margin-bottom: 30px;
    a {
      color: var(--purple-pale);
      text-decoration: none;
    }
  }
  &__subscribed {
    padding: 40px;
    background: var(--mid-gray-gradient);
    border-radius: 10px;
    color: var(--white);
    font-family: var(--font-regular);
    display: flex;
    justify-content: center;
    flex-flow: column;
    align-items: center;
    margin-bottom: 60px;
    &-title {
      font-weight: 700;
      font-size: 32px;
      line-height: 38px;
      margin-bottom: 10px;
      text-align: center;
    }
    &-subtitle {
      font-weight: 450;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 30px;
      color: var(--dusty-gray);
    }
    &-cta {
      .btn {
        text-decoration: none;
      }
    }
  }
  &__plans {
    &--cyber-monday {
      @include mobile {
        font-size: 16px;
        font-style: normal;
        font-weight: 900;
        line-height: 23px;
      }
      text-transform: uppercase;
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 14px;
      border-radius: 10px 10px 0px 0px;
      background: rgb(0, 143, 140);
      background: linear-gradient(
        90deg,
        rgba(0, 143, 140, 1) 0%,
        rgba(67, 101, 175, 1) 7%,
        rgba(129, 58, 212, 1) 14%,
        rgba(96, 55, 224, 1) 21%,
        rgba(45, 15, 79, 0.9108018207282913) 34%,
        rgba(45, 15, 79, 0) 86%
      );
      display: flex;
      padding: 13px 0px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      &--arrow {
        width: 13px;
        height: 13px;
      }
      &--text-mobile {
        display: block;
        @include mobile {
          display: none;
        }
      }
      &--text {
        display: none;
        @include mobile {
          display: block;
        }
      }
    }
  }
}
</style>
